import type { ReactNode } from "react";
import { Link, type LinkProps } from "react-router-dom";
import { buttonVariantClass } from "./Button";
import styles from "./ui.module.css";

type Variant = "primary" | "secondary" | "danger" | "ghost";

type Props = Omit<LinkProps, "className"> & {
  variant?: Variant;
  className?: string;
  children: ReactNode;
};

/** Canonical navigation control styled as a button — never nest Button inside Link. */
export function ButtonLink({ variant = "primary", className, children, ...rest }: Props) {
  return (
    <Link
      className={[styles.btn, styles.btnLink, buttonVariantClass(variant), className]
        .filter(Boolean)
        .join(" ")}
      {...rest}
    >
      {children}
    </Link>
  );
}
